import { render, staticRenderFns } from "./RenewalAlertpt.vue?vue&type=template&id=abae7176&"
import script from "./RenewalAlertpt.vue?vue&type=script&lang=js&"
export * from "./RenewalAlertpt.vue?vue&type=script&lang=js&"
import style0 from "./RenewalAlertpt.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports